import axios from "../lib/axios"
import { CREATE_COUPON } from "../lib/endpoints/coupon"

interface InputCreateCoupon {
    merchantIds: string[]
    couponCode?: string
    couponType?: string
    discount?: string
    buyByAmount?: string
    name?: string
    image?: string
    limitUsing?: string
    startDate?: string
    endDate?: string
    limitUsePerCustomer?: string
    forUserId?: string
}

export const createCouponService = async (input: InputCreateCoupon) => {
    try {
        const formData = new FormData();
        for (const [key, value] of Object.entries(input)) {
            if (Array.isArray(value)) {
                value.forEach((item) => formData.append(`${key}[]`, item));
            } else if (value) {
                formData.append(key, value);
            }
        }

        const response = await axios.post(CREATE_COUPON, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return response.data;
    } catch (error: any) {
        throw error.response?.data || error.message || 'An error occurred while creating the coupon';
    }
};